<template>
  <div class="main">
    <Navigation isMain />
    <router-view />
  </div>
</template>

<script>
import { getFacetValues } from '@/helpers/search'
import Navigation from '@/components/Navigation.vue'

export default {
  components: {
    Navigation,
  },
  mounted() {
    getFacetValues()
  },
}
</script>

<style lang="scss">
.main {
  padding-top: $navbar-height;
}
</style>
